import React from 'react';
import { Box, BoxProps, Theme, withStyles } from '@material-ui/core';
import { green } from 'globals/colors';

export const ContainerBox = withStyles(({ spacing }: Theme) => ({
  root: {
    position: 'relative',
    backgroundColor: green.V5,
    padding: spacing(1.6, 3),
    borderLeft: `1px solid ${green.MAIN}`,
  },
}))((props: BoxProps) => <Box {...props} />);

export default ContainerBox;
